import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'LoaderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-loader",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 6l0 -3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16.25 7.75l2.15 -2.15"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 12l3 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M16.25 16.25l2.15 2.15"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 18l0 3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.75 16.25l-2.15 2.15"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 12l-3 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7.75 7.75l-2.15 -2.15"
    }, null), _createTextVNode(" ")]);
  }
};